(function () {

	'use strict';

	/*global $:true, cologic:true */

	// Subcategory filter buttons of the "Element Crawler" (source type Product, option
	// tx_bte_crawler_show_filters - see the FilterBar section in ElementCrawler.fluid.html):
	// builds "All" + one button per subcategory found on the rendered product cards
	// (data-type / data-type-label), sorted by label, and lets the generic
	// cologic.initCrawlerControls engine (cologic-crawlerControls.js) do the actual
	// show/hide - incl. rebuilding the iosSlider in slider view. With fewer than two
	// subcategories the (hidden) bar is left as it is - nothing to choose from.

	let cologicElementCrawlerFilter = {

		initElementCrawlerFilter: function (rootSelector) {
			let $root = $(rootSelector);
			let $bar = $root.find('.element-crawler-filters');
			if ($root.length <= 0 || $bar.length <= 0) return;

			let labels = {};
			$root.find('.crawler-card').each(function () {
				let value = String($(this).attr('data-type') || '');
				if (value !== '' && value !== '0') {
					labels[value] = String($(this).attr('data-type-label') || value);
				}
			});
			let values = Object.keys(labels).sort(function (a, b) {
				return labels[a].localeCompare(labels[b]);
			});
			if (values.length < 2) return;

			let $input = $bar.find('.element-crawler-filter');
			let addButton = function (value, label) {
				$('<button type="button" class="element-crawler-filter-button"></button>')
					.attr('data-value', value)
					.attr('aria-pressed', value === '' ? 'true' : 'false')
					.toggleClass('is-active', value === '')
					.text(label)
					.appendTo($bar);
			};
			addButton('', $bar.attr('data-label-all') || 'All');
			values.forEach(function (value) {
				addButton(value, labels[value]);
			});

			$bar.on('click', '.element-crawler-filter-button', function () {
				let $button = $(this);
				$bar.find('.element-crawler-filter-button').removeClass('is-active').attr('aria-pressed', 'false');
				$button.addClass('is-active').attr('aria-pressed', 'true');
				$input.val(String($button.attr('data-value'))).trigger('change');
			});
			$bar.prop('hidden', false);

			cologic.initCrawlerControls(rootSelector, {
				card: '.crawler-card',
				filterControl: '.element-crawler-filter',
				filterAttribute: 'data-crawler-filter',
				grid: '.element-crawler-grid',
				slider: '.slider',
				sliderViewClass: 'element-crawler-view-slider',
				filters: [{name: 'type', dataKey: 'type', match: 'equals'}]
			});
		}

	};

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicElementCrawlerFilter);
}());
